import React, {FC} from 'react';
import Navigation from 'evcharging/containers/layout/Navigation';
import {createGetServerSideProps, StaticPageProps} from 'evcharging/app';
import Page from 'evcharging/components/Page';
import Footer from 'evcharging/containers/layout/Footer';
import Section from 'evcharging/containers/layout/Section';
import RequestConsultation from 'evcharging/containers/layout/RequestConsultation';
import {EV_CONSULTATION_LINK} from 'evcharging/app/seo/pages';
import {I18nPage} from "i18n/types/pages.enum";

const EvCalculatorPage: FC<StaticPageProps> = ({ page }) => (
  <Page
    locales={page.locales}
    title={page.meta_title}
    description={page.meta_description}
  >
    <Navigation />
    <Section background={'middle'}>
      <RequestConsultation />
    </Section>
    <Footer />
  </Page>
);

export const getServerSideProps = createGetServerSideProps(
  EV_CONSULTATION_LINK,
  undefined,
  [I18nPage.EvChargingCommon]
);

export default EvCalculatorPage;
